<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    :total-group="1"
    page-title="Detalhes do pagamento de conta"
    navigate-back-route="billPayment.list"
    navigate-page-after-save="billPayment.list"
    remove-buttons
  >
    <template slot="group-1">
      <form-group>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:id"
              v-model="payload.id"
              label="ID"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-date
              id="input:createdAt"
              v-model="payload.createdAt"
              label="Data da recusa"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:status"
              v-model="payload.status"
              label="Status"
              :loading="loading"
              :items="statusOptions"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-date
              id="input:updatedAt"
              v-model="payload.updatedAt"
              label="Data de atualização"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:getUpdatedBy"
              v-model="getUpdatedBy"
              label="Atualizado por"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:reason"
              v-model="payload.reason"
              label="Motivo da recusa"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="pb-4">
              <h5>Dados do estabelecimento</h5>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:userSystemId"
              v-model="payload.payment.userSystemId"
              label="ID Cardmais"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:nomLoja"
              v-model="store.nomLoja"
              label="Razão Social "
              :loading="storeLoading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-cpf-cnpj
              id="input:clientDocument"
              v-model="payload.payment.clientDocument"
              label="Documento"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:cidadeEnd"
              v-model="store.enderecoOutputJO.cidadeEnd"
              :loading="storeLoading"
              label="Cidade"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:estadoEnd"
              v-model="store.enderecoOutputJO.estadoEnd"
              :loading="storeLoading"
              :items="states"
              label="UF"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:storeName"
              v-model="payload.payment.storeName"
              label="ID Terminal"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="pb-4">
              <h5>Dados da transação “Pagamento de Conta” </h5>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:id"
              v-model="payload.payment.id"
              label="ID transação"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:payerName"
              v-model="payload.payment.payerName"
              label="Pagador"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:payeeName"
              v-model="payload.payment.payeeName"
              label="Beneficiário"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:invoiceNumber"
              v-model="payload.payment.invoiceNumber"
              label="Nº Título"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:bankName"
              v-model="payload.payment.bankName"
              label="Banco emissor"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-date
              id="input:paymentDate"
              v-model="payload.payment.paymentDate"
              label="Realizado em"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-money
              id="input:value"
              v-model="payload.payment.value"
              label="Valor título"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-money
              id="input:fine"
              v-model="payload.payment.fine"
              label="Multa"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:fee"
              v-model="payload.payment.fee"
              label="Juros"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-money
              id="input:commission"
              v-model="payload.payment.commission"
              label="Comissão"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:paymentMethodType"
              v-model="payload.payment.paymentMethodType"
              label="Forma de pagamento"
              :items="paymentMethodTypes"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-money
              id="input:totalValue"
              v-model="payload.payment.totalValue"
              label="Valor Total"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row align="start">
          <v-col cols="6">
            <v-textarea
              id="input:digitableLine"
              v-model="payload.payment.digitableLine"
              label="Linha digitável"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="pb-4">
              <h5>Dados do cartão</h5>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:nsu"
              v-model="payload.cardBilling.nsu"
              label="NSU"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-select
              id="input:paymentMethodType"
              v-model="payload.cardBilling.paymentMethodType"
              label="Tipo de pagamento"
              :loading="loading"
              :items="paymentMethodTypes"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:installments"
              v-model="payload.cardBilling.installments"
              label="Quantidade de parcelas"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-money
              id="input:cardBilling.amount"
              v-model="payload.cardBilling.amount"
              label="Valor"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:pan"
              v-model="payload.cardBilling.pan"
              label="Número do Cartão"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:authorization"
              v-model="payload.cardBilling.authorization"
              label="Autorização"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:labelName"
              v-model="payload.cardBilling.labelName"
              label="Bandeira"
              :loading="loading"
              outlined
              disabled
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import InputCpfCnpj from '@/app/arch/components/global-components/InputCpfCnpj.vue';
import StoreRequest from '@/app/users/services/StoreRequest';
import ReversalBillPaymentStatus from '@/app/arch/enums/ReversalBillPaymentStatus';
import UF from '@/app/arch/enums/UF';
import BillPaymentService from './BillPaymentService';
import StatementPaymentMethod from '../../../../arch/enums/StatementPaymentMethod';

export default {
  name: 'BillPaymentForm',
  components: { CrudForm, FormGroup, InputCpfCnpj },
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: BillPaymentService,
    loading: false,
    storeLoading: false,
    storeRequest: StoreRequest,
    statusOptions: ReversalBillPaymentStatus,
    paymentMethodTypes: StatementPaymentMethod,
    states: UF,
    payload: {
      approvedBy: '',
      reprovedBy: '',
      reversedBy: '',
      payment: {
        clientName: '',
        storeName: '',
        status: '',
        minutesLeftToSendReceipt: '',
        waitMinutesToSendReceipt: '',
        requestPinPaymentCreditCard: '',
        requestPinPayment: '',
        requestPinPaymentPostPaid: '',
        clientDocument: '',
        id: '',
        userSystemId: '',
        clientId: '',
        storeId: '',
        invoiceNumber: '',
        payerName: '',
        payerDocument: '',
        dueDate: '',
        paymentDate: '',
        value: '',
        fine: '',
        interest: '',
        commission: '',
        fee: '',
        discount: '',
        totalValue: '',
        payeeName: '',
        payeeDocument: '',
        bankAccountId: '',
        bankAccountCode: '',
        agency: '',
        account: '',
        assignorName: '',
        assignorDocument: '',
        bankCode: '',
        bankName: '',
        barCode: '',
        digitableLine: '',
        nsu: '',
        authentication: '',
        paymentId: '',
        transactionUuid: '',
        allowsPartialPayment: '',
        minValue: '',
        maxValue: '',
        paymentDeadline: '',
        email: '',
        cellPhoneNumber: '',
        scheduledDate: '',
        deviceId: '',
        nsuCardBilling: '',
        paymentChannel: '',
        paymentMethodType: '',
        parcelaTaxaId: '',
        quantidadeParcela: '',
        nextBusinessDay: '',
        pagoParcial: '',
      },
      cardBilling: {
        amount: '',
        valorOriginal: '',
        valorTotal: '',
        brand: '',
        date: '',
        document: '',
        parentDocument: '',
        idProduct: '',
        installments: '',
        labelName: '',
        nsu: '',
        serialNumber: '',
        pan: '',
        cardName: '',
        atc: '',
        processCode: '',
        type: '',
        transactionId: '',
        authorization: '',
        cryptogramTransaction: '',
        fee: '',
        referenceId: '',
        clientId: '',
        storeId: '',
        acquirer: '',
        entryMode: '',
        status: '',
        chargeOriginForm: '',
        paymentMethodType: '',
        aid: '',
        authorizationPassword: '',
        parcelaTaxaId: '',
        parcelaTaxa: {
          quantidadeParcela: '',
          taxa: '',
          valorMinimo: '',
          valorMaximo: '',
          productType: '',
          createdAt: '',
          updatedAt: '',
          id: '',
        },
        bloqueadoPorPrevencaoDeFraude: '',
        motivoDoBloqueio: '',
        requestPinCreditCard: '',
        createdAt: '',
        updatedAt: '',
        id: '',
      },
      status: '',
      chargebackType: '',
      id: '',
      createdAt: '',
      updatedAt: '',
      isActive: '',
    },
    store: {
      id: '',
      createdDate: '',
      updatedDate: '',
      deletedDate: '',
      idCliente: '',
      nomLoja: '',
      numTelefone: '',
      idEndereco: '',
      txtComplementoEndereco: '',
      numEndereco: '',
      indAdiquirenciaHabilitada: '',
      indEccardHabilitada: '',
      idEstabelecimentoAdq: '',
      indStatus: 'ATIVO',
      numCnpj: '',
      idClienteSgv: '',
      tokenTransacao: '',
      indHabilitadoEncerramento: '',
      idEmpresa: '',
      idSegmento: '',
      faturamentoAnual: '',
      enderecoOutputJO: {
        idEndereco: '',
        logradEnd: '',
        bairroEnd: '',
        cidadeEnd: '',
        estadoEnd: '',
        numCep: '',
        logradouro: '',
        tipoLogradouro: '',
      },
      numCpfCnpjCliente: '',
      nomSegmento: '',
    },
  }),
  computed: {
    getUpdatedBy() {
      const {
        status, approvedBy, reprovedBy, reversedBy,
      } = this.payload;

      switch (status) {
        case 'Approved':
          return approvedBy;
        case 'Reproved':
          return reprovedBy;
        case 'Reversed':
          return reversedBy;
        default:
          return '';
      }
    },
    storeId() {
      return this.payload.payment.storeId;
    },
  },
  provide() {
    return {
      setDataLoading: (value) => {
        this.loading = value;
      },
    };
  },
  watch: {
    storeId: {
      immediate: true,
      handler(id) {
        if (Number(id) > 0) {
          this.getStore();
        }
      },
    },
  },
  methods: {
    getStore() {
      this.storeLoading = true;
      this.callService(
        this.storeRequest.get(this.storeId),
        (res) => {
          this.storeLoading = false;
          if (res) {
            this.store = this.overrideNullProperties(res.data, this.store);
          }
        },
      );
    },
  },
};
</script>
